import React, { useEffect } from "react";
import { NewNavbar, BreadCrumbsNew, NewFooter } from "../../components";
import { TabAzTest } from "./BloodTestcomponents/TabAzTest";
import { useLocation } from "react-router-dom";
import { categoriesData } from "../../data/BloodTestCategories";
import Seo from "../../components/Seo";
import { formatPageTitle, shopUrl, stripHtml } from "../../lib/seoUtils";

const AllBloodTest = () => {
  const location = useLocation();
  const searchParams = new URLSearchParams(location.search);
  const paramCategory = searchParams.get("category"); // Retrieves 'general-health'

  const breadcrumbs = [
    { label: "Home", path: "/" },
    {
      label: "Blood Testing",
      path: "/blood-testing",
    },
    { label: "A-Z Tests" },
  ];

  const matchedCategory = categoriesData.find(
    (cat) => cat.slug === paramCategory
  );

  const title = formatPageTitle(
    matchedCategory ? matchedCategory.heading : "A-Z Blood Tests"
  );

  const description = matchedCategory
    ? matchedCategory.description
    : "Explore our full A-Z list of blood tests, including individual biomarkers and profiles. Easily filter by health category or search to find the test that best suits your needs. Can't find what you're looking for? Get in touch - we may be able to help.";

  const canonicalUrl = shopUrl(
    "/a-z-tests",
    paramCategory ? `?category=${paramCategory}` : ""
  );

  useEffect(() => {
    if (typeof document !== "undefined") {
      const meta = document.createElement("meta");
      meta.name = "disableReaderMode";
      meta.content = "true";
      document.head.appendChild(meta);
    }
  }, []);

  useEffect(() => {
    // Disable reader mode by constantly shifting DOM
    if (typeof window !== 'undefined' && /iPad|iPhone|iPod/.test(navigator.userAgent)) {
      const timer = setInterval(() => {
        document.body.style.zoom = '99.99%';
        setTimeout(() => { document.body.style.zoom = '100%' }, 10);
      }, 3000);
      return () => clearInterval(timer);
    }
  }, []);

  return (
    <main>
      <Seo
        title={title}
        description={stripHtml(description)}
        canonical={canonicalUrl}
        url={canonicalUrl}
        image={shopUrl("/assets/new_assets/t-ban-pexels-karolina-4047146-scaled.jpg")}
        structuredData={{
          "@context": "https://schema.org",
          "@type": "CollectionPage",
          name: title,
          description: description,
          url: canonicalUrl,
          mainEntity: {
            "@type": "MedicalWebPage",
            "about": {
              "@type": "MedicalTestPanel",
              "name": matchedCategory ? `${matchedCategory.heading}` : "Comprehensive Blood Tests",
              "description": description,
              "medicalSpecialty": matchedCategory?.medicalSpecialty || "Pathology"
            }
          },
          publisher: {
            "@type": "Organization",
            name: "My Private Chemist",
            address: {
              "@type": "PostalAddress",
              streetAddress: "Longcroft House, 2-8 Victoria Avenue",
              addressLocality: "London",
              postalCode: "EC2M 4NS",
              addressCountry: "GB",
            },
          },
        }}
      />
      <div className="breadcrumnb-img-bg">
        <div className="container">
          <NewNavbar />
          <BreadCrumbsNew breadcrumbs={breadcrumbs} title={"A-Z Tests"} />
        </div>
      </div>

      <div className="container my-5">
        <TabAzTest paramCategory={paramCategory} />
      </div>
      <NewFooter />
    </main>
  );
};

export { AllBloodTest };
